module.exports = "/images/vendor/flag-icon-css/flags/4x3/ng.svg?992459a3d0f22849b493a540e1564bb0";